import { useTranslation } from 'react-i18next';
import { useMutation } from 'react-query';

import { useCustomToast } from 'hooks';
//services
import { forgotPassword } from 'modules/account/features/forgotPassword/api';

export const useMutationForgotPassword = (changeView?: () => void) => {
  const { t } = useTranslation();
  const { successToast, errorToast } = useCustomToast();
  const { mutate, status } = useMutation(forgotPassword, {
    onSuccess: () => {
      successToast('Success');
      changeView && changeView();
    },
    onError: (error: any) => {
      const errorMessage = error?.response?.data?.ErrorDescription;
      errorToast(errorMessage || t('User not found.'));
    },
  });

  return { mutate, status };
};
